import { render, staticRenderFns } from "./IrregularidadeForm.vue?vue&type=template&id=b43b5e40&"
import script from "./IrregularidadeForm.vue?vue&type=script&lang=js&"
export * from "./IrregularidadeForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports